// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vpjC4","col":"styles_col__1IGqf"};